<template>
  <b-modal
    ref="modal"
    id="confirm-modal"
    hide-header
    centered
    @show="onShow"
    @hide="onHide"
  >
    <div class="title text-center"><h4>{{ title }}</h4>
    </div>
    <div slot="modal-footer">
      <primary-button class="float-right" @click="ok" red :text="$t('YES')"/>
      <primary-button @click="off" blue :text="$t('NO')" />
    </div>
  </b-modal>
</template>

<script>
import { watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import PrimaryButton from '@/components/PrimaryButton';

const { useGetters: useModalGetters, useActions: useModalActions } = createNamespacedHelpers('modal');
const { useState: userConfirmState } = createNamespacedHelpers('confirm');

export default {
  name: 'ConfirmModal',
  components: {
    PrimaryButton,
  },
  setup(props, { refs }) {
    const { isConfirmModalActive: isOpen } = useModalGetters(['isConfirmModalActive']);
    const { toggleConfirmModal: toggleConfirm } = useModalActions(['toggleConfirmModal']);

    const { title } = userConfirmState(['title']);
    const { onConfirm } = userConfirmState(['onConfirm']);

    const ok = () => {
      onConfirm.value();
      refs.modal.hide();
    };

    const off = () => {
      refs.modal.hide();
    };
    const onShow = () => {
    };
    const onHide = () => {
      toggleConfirm(false);
    };

    watch(isOpen, (newVal) => {
      const { modal } = refs;

      if (newVal) modal.show();
      else modal.hide();
    });

    return {
      isOpen,
      off,
      onHide,
      title,
      onConfirm,
      onShow,
      ok,
      toggleConfirm
    };
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";
#confirm-modal {
  .modal-footer {
    border: 0;
    padding-bottom: 26px;
    padding-right: 120px;

    .primary-button {
      margin-left: 15px;
      border-radius: 4px;
    }
  }
  .title {
    padding-top: 20px;

    h4 {
      font-weight: bold;
      font-size: 18px;
      max-width: 300px;
      margin: auto;
    }

  }

  @media (max-width: 767px) {
    .modal-footer {
      justify-content: center;

      .btn {
        margin-left: 70px;
      }

      .primary-button {
        display: block;
        width: 100%;
        margin-bottom: 10px;
        border-radius: 3px;
        margin-left: unset !important;
      }
    }
  }
}
</style>
